import React from 'react'
import { IBlog } from '../Blogs'
import moment from "moment"
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

function BlogCardSm({ data }: { data: IBlog }) {
  const nav = useNavigate()
  const { slug, thumbnailUrl, title, publishDate } = data

  const onClickCard = () => {
    nav(`/b/${slug}`)
  }

  const onClickCopy = (text: string) => {
    navigator.clipboard.writeText(text)
    toast.success('Link Copied', { autoClose: 1000, hideProgressBar: true })
  }

  return (
    <article className='blog-card-sm-container' onClick={onClickCard}>
      <div className="blog-image">
        <img src={thumbnailUrl} alt="" />
      </div>
      <h5 className="blog-title" title={title}>{title}</h5>
      <div className="publication-share">
        {/* <button>Read</button> */}
        <div className="date-and-share">
          <span>Published on {publishDate && moment(publishDate).format('DD/MM/yyyy') || '-'}</span>
          <i className="ri-share-line" onClick={(e) => {
            e.stopPropagation()
            onClickCopy(`${window.location.origin}/b/${slug}`)
          }}></i>
        </div>
      </div>
    </article>
  )
}

export default BlogCardSm